import { valueExistsTS } from 'utilsTS'
import { cloneInjectableElement } from './InjectablesElementsPanel'

export const FORM_EDITOR_REDUX_KEYS = [
  'sections',
  'elementsInStack',
  'copied'
]

export const FORM_EDITOR_DATA_KEYS = [
  'sections',
  'injectableComponents',
  'autosave',
  'version',
  'enableMultiuser',
  'pdfProps',
  'style',
  'formType',
  'showSectionTitlesAsHeaders',
  'showFormTitleInPdf',
  'renderElementsWithTitles',
  'hideFormTitle',
  'doNotUseStickyHeader',
  'showPrintButton',
  'objectsConnected',
  'displaySaveFailedDialog',
  'displayUnsavedWarning',
  'displayesSavedInMeantimeWarning',
  'restrictAccessForRoles',
  'restrictAccessType',
  'translatedFor',
  // 'overrideFormLanguage',
  'supportedFormType'
]

export const parseFormItemToNewStandard = (item: any, reusableComponentsMap: any): void => {
  if ('title' in item) {
    delete item.titleEN
    delete item.titleFR
  }
  if ('tooltip' in item) {
    delete item.tooltipEN
    delete item.tooltipFR
  }
  if ('helpText' in item) {
    delete item.helpTextEN
    delete item.helpTextFR
  }

  if ('padding' in item || item.padding === 0) {
    const useBase = typeof item.padding !== 'object'
    if (useBase) {
      item.padding = {
        paddingLeft: String(item.padding),
        paddingRight: String(item.padding),
        paddingTop: String(item.padding),
        paddingBottom: String(item.padding)
      }
    }
  }
  delete item.editMode
  delete item.selected
  if ('columns' in item) {
    // Convert group element
    if ('pdfBorderDisplay' in item || 'pdfCardDisplay' in item) {
      delete item?.pdfCardDisplay
      delete item?.pdfBorderDisplay
      item.pdfElementStyle = 'card'
    } else if (!('pdfElementStyle' in item)) {
      item.pdfElementStyle = 'plain'
    }
  }

  if ('typeProps' in item) {
    if ('html' in item.typeProps) {
      delete item.typeProps.htmlEN
      delete item.typeProps.htmlEn
      delete item.typeProps.htmlFR
      delete item.typeProps.htmlFrench
    }

    if ('roles' in item.typeProps) {
      item.typeProps.roles.forEach(role => {
        if ('apiValue' in role && !('sfField' in role)) {
          switch (role.apiValue) {
            case 'First Signer':
              role.sfField = 'aff_grantee_first_signer__c'
              break
            case 'Second Signer':
              role.sfField = 'aff_grantee_second_signer__c'
              break
            case 'Primary Contact':
              role.sfField = 'aff_grantee_primary_contact__c'
              break
            case 'Secondary Contact':
              role.sfField = 'Secondary_Contact__c'
              break
            case 'Accounting Contact':
              role.sfField = 'Accounting_Contact__c'
              break
            default:
              break
          }
        }
      })
    }

    // Convert old config to new functionality
    delete item.typeProps.longitude
    delete item.typeProps.latitude
    delete item.typeProps.street
    delete item.typeProps.city
    delete item.typeProps.zipCode
    if ('pdfCardDisplay' in item.typeProps || 'pdfBorderDisplay' in item.typeProps) {
      delete item?.pdfCardDisplay
      delete item?.pdfBorderDisplay
      item.pdfElementStyle = 'card'
    } else if (!('pdfElementStyle' in item.typeProps)) {
      item.typeProps.pdfElementStyle = 'plain'
    }

    if ('connectedObject' in item.typeProps) {
      item.typeProps.isConnected = true
      item.typeProps.connectedTo = [
        {
          connectedObject: item.typeProps.connectedObject,
          connectedField: item.typeProps.connectedField
        }
      ]
      delete item.typeProps.connectedObject
      delete item.typeProps.connectedField
    }
  }
  if ('elements' in item) {
    item.elements.forEach((element, index) => {
      if ('injectableId' in element) {
        if (valueExistsTS(reusableComponentsMap[element.injectableId])) {
          const updated = cloneInjectableElement({
            item: element,
            componentsMap: reusableComponentsMap,
            editor: true
          })
          item.elements[index] = updated
        } else {
          delete element.injectableId
          delete element.injectableName
        }
      }
      parseFormItemToNewStandard(element, reusableComponentsMap)
    })
  }
}
